import { imageUrl } from "@/services/BaseUrl";

export const MAX_IMAGE_SIZE_KB = 200;
export const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_KB * 1024; // 204,800 bytes

/**
 * Validates whether a file is within the maximum image size limit (200KB).
 * @param file The File object to validate
 * @returns { valid: boolean, error?: string }
 */
export const validateImageSize = (file: File): { valid: boolean; error?: string } => {
  if (!file) {
    return { valid: true };
  }

  if (file.size > MAX_IMAGE_SIZE_BYTES) {
    const actualSizeKB = Math.round(file.size / 1024);
    return {
      valid: false,
      error: `Image size must be under ${MAX_IMAGE_SIZE_KB}KB. This file is ${actualSizeKB}KB. Please compress the image and try again.`,
    };
  }

  return { valid: true };
};

/**
 * Validates an array or FileList of files against the maximum image size limit (200KB).
 * @param files FileList or Array of File objects
 * @returns { valid: boolean, error?: string }
 */
export const validateImageFiles = (files: FileList | File[]): { valid: boolean; error?: string } => {
  const fileArray = Array.from(files);
  for (const file of fileArray) {
    const result = validateImageSize(file);
    if (!result.valid) {
      return result;
    }
  }
  return { valid: true };
};

export const getValidImageUrl = (img: any): string | null => {
    if (!img) return null;
    if (typeof img !== 'string') return null;
    let cleanImg = img.trim();
    if (!cleanImg) return null;

    // Handle accidentally prefixed slashes before full URLs (e.g. /https://...)
    if (cleanImg.startsWith('/http://') || cleanImg.startsWith('/https://')) {
        cleanImg = cleanImg.substring(1);
    }

    if (cleanImg.startsWith('http://') || cleanImg.startsWith('https://') || cleanImg.startsWith('data:') || cleanImg.startsWith('blob:')) {
        return cleanImg;
    }
    const path = cleanImg.replace(/\\/g, '/');
    return `${imageUrl}${path.startsWith('/') ? '' : '/'}${path}`;
};

